import PropTypes from 'prop-types';
import styles from './ReleaseImageCardList.module.scss';
import ReleaseImageCard from '../ReleaseImageCard';
import classNames from 'classnames';

const ReleaseImageCardList = ({ items }) => {
    const classes = classNames(styles['ReleaseImageCardList']);

    const sortedItems = items && [...items].sort((a, b) => (b.isHighlighted ? 1 : 0) - (a.isHighlighted ? 1 : 0));

    return (
        <div className={classes}>
            <div className={styles['ReleaseImageCardList__Container']}>
                {sortedItems && (
                    <div className={styles['ReleaseImageCardList__List']}>
                        {sortedItems.map((item, i) => {
                            const applyTextLeft = sortedItems[0].isHighlighted ? i % 2 !== 1 : i % 2 !== 0;

                            return (
                                <div
                                    key={i}
                                    className={classNames(styles['ReleaseImageCardList__Item'])}
                                >
                                    <ReleaseImageCard
                                        {...item}
                                        modifiers={applyTextLeft ? ['TextLeft'] : []}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

ReleaseImageCardList.propTypes = { 
    items: PropTypes.array.isRequired, 
};

export default ReleaseImageCardList;
